<template>
  <main class="main">
      <div class="table">
        <loading-container :loading="loading" >
        <table >
          <tr>
            <th>Дата импорта</th>
          </tr>
          <tr v-for="(item, idx) in logs" :key="idx">
            <td>
                <router-link :to="'log/'+item.id + '/errors'" tag="a">
                    {{$moment(item.created_at).format('DD.MM.YYYY HH:mm:ss')}}
                </router-link>
            </td>
          </tr>
        </table>
      </loading-container>
      </div>
      <pagination
          :key="paginat"
          v-show="last_page > 1"
          v-model="page"
          :page-count="last_page"
      />
  </main>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import Pagination from "@/components/pagination";

export default {
  name: "import-log",
  components: {
    LoadingContainer,
    Pagination
  },
  data: ()=>({
    last_page: 0,
    paginat: null,
    page: 0,
    loading: true,
    logs: null
  }),
  mounted() {
    this.getLogs();
  },
  methods: {
    getLogs(){
      this.$http.post('/get-import-logs', {
        token: localStorage.getItem('token'),
        page:this.page
      }).then(({data}) => {
        if (data.logs){
          this.logs = data.logs.data;
          this.last_page = data.logs.last_page;
          this.page = data.logs.current_page;
          this.loading = false;
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  watch: {
    page: function (val) {
      if (val >= 1) {
        this.loading = true;
        this.getLogs();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.table{
  margin-top: 20px;
  table{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    tr{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;

      th{
        color: #2D3137;
      }
      td{
        color: #636974;
        &.done{
          color: #2cb181;
        }
      }
    }
  }
}


</style>
